// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
const is_node = typeof module=='object' && module.exports;
const define = !is_node ? self.define
    : require('../../../../util/require_node.js').define(module, '..');
define([], ()=>{
const E = {};

E.valid_login = passwd=>{
    if (!passwd)
        return 'empty';
    return null;
};

function byte_length(str){
  let s = str.length;
  for (let i=str.length-1; i>=0; i--)
  {
    var code = str.charCodeAt(i);
    if (code>0x7f && code<=0x7ff)
        s++;
    else if (code>0x7ff && code<=0xffff)
        s+=2;
    if (code>=0xDC00 && code<=0xDFFF)
        i--;
  }
  return s;
}

E.valid_signup = passwd=>{
    if (!passwd)
        return 'empty';
    if (passwd.length<8)
        return 'short';
    // bcrypt uses only the first 72 bytes of a string
    if (byte_length(passwd)>72)
        return 'long';
    const has_digit = /\d/.test(passwd);
    const has_upper = /[A-Z]/.test(passwd);
    const has_lower = /[a-z]/.test(passwd);
    const has_special = specials_whitelist
        .split('')
        .some(c=>passwd.includes(c));
    const valid = has_digit && has_upper && has_lower && has_special;
    if (!valid)
        return 'simple';
    const is_email_like = /[\w-.+]+@[\w-]+\.[a-zA-Z]+/.test(passwd);
    if (is_email_like)
        return 'email_like';
    return null;
};

E.valid_zone_passwd = p=>{
    if (!p)
        return 'Password is empty';
    if (p.length<8)
        return 'Password is too short';
    if (p.length>48)
        return 'Password is too long';
    let specials = get_all_matches(/[^a-zA-Z0-9]/g, p);
    if (specials.some(c=>!specials_whitelist.includes(c)))
    {
        return 'Only the following special characters are allowed: '
            +specials_whitelist;
    }
    if (!/\d/.test(p) || !/[a-zA-Z]/.test(p))
        return 'Password should contain both letters and numbers';
};

const specials_whitelist = '!?&$~#@_=+-*/%^';

const shuffle = a=>{
    let curr_i = a.length, rnd_i;
    while (--curr_i){
      rnd_i = Math.floor(Math.random() * curr_i);
      [a[curr_i], a[rnd_i]] = [
        a[rnd_i], a[curr_i]];
    }
    return a;
};

E.gen_passwd = (len=12)=>{
    const numbers = '0123456789';
    const chars = 'abcdefghijklmnopqrstuvwxyz';
    const all = numbers+chars;
    let res = Array(len<8 ? 8 : len);
    res[0] = numbers;
    res[1] = chars;
    res.fill(all, 2);
    res = res.map(i=>i[Math.floor(Math.random() * i.length)]);
    return shuffle(res).join('');
};

const get_all_matches = (re, str)=>{
    let res = [];
    for (let [m] of str.matchAll(re))
        res.push(m);
    return res;
};

return E; }); // eslint-disable-line
